import React from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from 'common/components/texts/Texts';
import Button from 'common/components/button/Button';
import Logger from 'common/services/Logger';
import { LOGGER_LOG_TYPE } from 'Config';

interface Props {
    children: React.ReactNode;
}

interface State {
    hasError: boolean;
}

const Fallback: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, minHeight: '60vh', textAlign: 'center', padding: 24 }}>
            <Header>{t('messages.unexpected_error', { defaultValue: 'Ocorreu um erro inesperado.' })}</Header>
            <Button size='small' onClick={() => window.location.reload()}>
                {t('common.reload', { defaultValue: 'Recarregar' })}
            </Button>
        </div>
    );
};

class ErrorBoundary extends React.Component<Props, State> {
    constructor (props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError (): State {
        return { hasError: true };
    }

    componentDidCatch (error: Error, info: React.ErrorInfo) {
        Logger.error(LOGGER_LOG_TYPE.BOUNDARY, error.message, {
            stack: error.stack,
            componentStack: info.componentStack,
            error
        });
    }

    render () {
        if (this.state.hasError) {
            return <Fallback />;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
